import React from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';

import ToastController from './toastController';

// React 19 Migration: Using default parameters instead of defaultProps
const Toast = ({
  children,
  type = 'info',
  className = '',
  autoClose = false,
  placement = 'tr',
  ...props
}) => {
  return createPortal(
    <ToastController
      {...props}
      type={type}
      className={className}
      autoClose={autoClose}
      placement={placement}
    >
      {children}
    </ToastController>,
    document.querySelector('#toast')
  );
};

Toast.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.string,
  autoClose: PropTypes.bool,
  placement: PropTypes.string,
};

export default Toast;
